import { useMemo } from 'react'
import moment from 'moment'
import Cookie from "js-cookie"

export async function copyTextToClipboard(text) {
    let inputc = document.body.appendChild(document.createElement('input'))
    inputc.value = text
    inputc.select()
    document.execCommand('copy')
    inputc.parentNode.removeChild(inputc)
}


export const routerToPathAndQuery = (router, key, val, multiple, clearKeyItems) => {
    let newVal = val?.toString()

    if (multiple) {
        let paramsArr = getParamsByKey(router, key)
        if (paramsArr) {
            paramsArr = paramsArr.indexOf(newVal) > -1 ? paramsArr.filter((k) => k !== newVal) : [...paramsArr, newVal]
            newVal = paramsArr.join(',')
        }
    }

    const queryObj = { ...router.query, [key]: newVal }
    delete queryObj['params']

    if (clearKeyItems) {
        delete queryObj[clearKeyItems]
    }

    if (router.query[key] === newVal || !newVal) {
        delete queryObj[key]
    }

    const paramsPath = router.query.params && router.query.params.join('/')
    let pathname = router.pathname
    pathname = pathname.replace('[[...params]]', paramsPath || '')

    return { pathname, query: queryObj }
}

export const useRules = (props) => {
    return useMemo(() => {
        let r = [...props.rules]

        if (props.required) {
            r.unshift({ required: true })
        }

        return r
    }, [props.required, props.rules])
}

export const objectToFormData = (data, formData, parentKey) => {
    const newFormData = formData || new FormData()


    if (data && typeof data === 'object' && !(data instanceof Date) && !(data instanceof File)) {
        Object.keys(data).forEach((key) => {
            const isFilesArray = !isNaN(parseInt(key)) && (data[key] instanceof File)
            objectToFormData(data[key], newFormData, parentKey ? (isFilesArray ? `${parentKey}` : `${parentKey}[${key}]`) : key)
        })
    } else {
        const value = data == null ? '' : data
        newFormData.append(parentKey, value)
    }

    return newFormData
}

export const asyncFunctionDecorator = (asyncFunc) => {
    return asyncFunc().catch((err) => {
        return Promise.reject(err.response)
    })
}

export const getRequestCookies = (ctx, key) => {
    return ctx?.req?.cookies?.[key]
}

export const getCookie = (key) => {
    return Cookie.get(key)
}

export const setCookie = (key, cookie) => {
    Cookie.set(key, cookie)
}

export const removeCookie = (key) => {
    Cookie.remove(key)
}

export const diffForHumans = (date) => {
    return moment(date).fromNow()
}